import { FormModeAdapter } from "./definitions";
import { CreateAdapter } from "./CreateAdapter";
import { EditAdapter } from "./EditAdapter";
import { DraftAdapter } from "./DraftAdapter";
import { WizardAdapter } from "./WizardAdapter";

/**
 * Factory function to create the appropriate adapter based on form props
 * This centralizes the adapter selection logic
 */
export function createFormAdapter(mode: string): FormModeAdapter {
  switch (mode) {
    case "create":
      return new CreateAdapter();

    case "edit":
      return new EditAdapter();

    case "draft":
      return new DraftAdapter();

    case "wizard":
      return new WizardAdapter();

    default:
      throw new Error(`Unsupported form mode: ${mode}`);
  }
}
